'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import ProfessorPortalContent from './components/ProfessorPortalContent';

export default function ProfessorPortalPage() {
  return (
    <AppLayout role="professional" campusMode="pro">
      <ProfessorPortalContent />
    </AppLayout>
  );
}
